import { getAll } from 'redux/api/AccountRoles'

import { Dispatch } from 'redux'

import * as actions from './actions'

export function tryGetAllUserRoles(dispatch: Dispatch) {
  dispatch(actions.getAll())

  getAll()
    .then((response) => {
      dispatch(actions.getAllSuccess(response.data))
    })
    .catch(() => {
      dispatch(actions.getAllFailed())
    })
}
